import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/psychic.services";
import Breadcrums from "../../common/breadcrumbs";
import { AllLanguages } from "../../../../utils/Constants";

const AstrologerView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Astrologer"),
      url: "/admin/astrologer-management/astrologer/list/1",
    },
    { title: t("View"), url: "" },
  ];


  useEffect(() => {
    Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Image")}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault.profile_image
                                  ? showdefault.profile_image
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>

                        {showdefault?.email && (
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>
                        )}
                        {showdefault?.phone_number && (
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>
                            {showdefault && showdefault?.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr>)}
                        <tr>
                          <th>{t("Expertise")}</th>
                          <td>
                            {showdefault && showdefault?.expertise && Array.isArray(showdefault.expertise) && showdefault.expertise.length > 0 ?
                              showdefault.expertise.map((item, index) => {
                                const price = parseFloat(item?.price_per_minute);  // Convert string to number
                                return (
                                  !isNaN(price) && price > 0 && item?.price_per_minute ? (
                                    <span key={index} className="badge bg-primary me-1">
                                      {item?.expertise_type} - ₹{price.toFixed(2)} / min
                                    </span>
                                  ) : null
                                );
                              })
                              : null}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Online Puja")}</th>
                          <td>
                            {showdefault && showdefault?.online_puja && Array.isArray(showdefault.online_puja) && showdefault.online_puja.length > 0 ?
                              showdefault.online_puja.map((item, index) => {
                                const price = parseFloat(item?.price_per_minute);  // Convert string to number
                                return (
                                  !isNaN(price) && price > 0 && item?.price_per_minute ? (
                                    <span key={index} className="badge bg-primary me-1">
                                      {item?.puja_type} - ₹{price.toFixed(2)} / min
                                    </span>
                                  ) : "-"
                                );
                              })
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Experience")}</th>
                          <td>
                            {showdefault && showdefault?.experience
                              ? showdefault.experience + " years"
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Language spoken")}</th>
                          <td>
                            {showdefault && showdefault?.language_spoken && Array.isArray(showdefault.language_spoken) && showdefault.language_spoken.length > 0 ?
                              showdefault.language_spoken.map( (item, index) => (
                                <span key={index} className="badge bg-primary me-1">
                                  {AllLanguages[`${item}`] ? AllLanguages[`${item}`] : item}
                                </span>
                              ))
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Admin Rating</th>
                          <td>
                            {showdefault && showdefault?.rating
                              ? showdefault.rating
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>User Average Rating</th>
                          <td>
                            {showdefault && showdefault?.average_rating
                              ? showdefault.average_rating
                              : "N/A"}
                          </td>
                        </tr>
                        
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="mt-2 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  // navigate("/admin/psychic-management/psychic/list/1")
                  navigate(-1)
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AstrologerView;
